<template>
  <div class="error-page-wrapper loading-component">
    <div class="error-content">
      <h4>Loading</h4>
      <p>Page is being loaded.</p>
    </div>
  </div>
</template>
